import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import NPCEvent from "./NPCEvent";
import NPCContent from "../../../../lib/html5-software-library/src/ranj/eng/content/NPCContent";

/**
* NPCModel.js
* 
* Created on 7-nov-2013, 11:35:20
*
* @author Ivo Swartjes for Ranj
**/
export default class NPCModel {
    constructor(dispatcher) {
        this._dispatcher = dispatcher;
        this._pullDialogsByNpcID = {};
    }

    addNpc(npcContent) {
        if (isNull(npcContent.getNpcID())) {
            throw new Error("Trying to add NPC without NPC ID!");
        }
        this._pullDialogsByNpcID[npcContent.getNpcID()] = npcContent;
        const npcEvent = new NPCEvent(NPCEvent.NPC_ADDED, npcContent);
        this._dispatcher.dispatch(npcEvent.type, npcEvent);
    }

    getNpcByNpcID(npcID) {
        return this._pullDialogsByNpcID[npcID];
    }

    getDisplayNameForNpcId(npcId) {
        const npc = this.getNpcByNpcID(npcId);
        if (!npc) return npcId;

        return npc.getName() || npc.getEmail() || npcId;
    }

    getNPCs() {
        const npcs = [];
        for (const npcID in this._pullDialogsByNpcID) {
            const content = this._pullDialogsByNpcID[npcID];
            npcs.push(content);
        }
        return npcs;
    }

    toObject() {
        let serializablePullDialogsByNpcID = {};
        for (const npcId in this._pullDialogsByNpcID) {
            const npcContent = this._pullDialogsByNpcID[npcId];
            serializablePullDialogsByNpcID[npcId] = npcContent.convertToObject();
        }

        return {
            pullDialogsByNpcID: serializablePullDialogsByNpcID,
        }
    }

    fromObject(obj, languagePack) {
        Object.keys(obj.pullDialogsByNpcID).map(k => {
            const npcContent = new NPCContent(languagePack);
            npcContent.setPropertiesFromObject(obj.pullDialogsByNpcID[k]);

            this._pullDialogsByNpcID[k] = npcContent;
        });

        return this;
    }
}


